import React from "react";
import { Typography, Box } from "@mui/material";
import CustomTable from "../../components/Table/Table";
import { useLogsViewModel } from "./LogsViewModel";
import HistoryIcon from "@mui/icons-material/History";
import ViewLog from "./ViewLog";

const Logs = () => {
  const {
    logs,
    loading,
    error,
    columns,
    columnFilters,
    fixedColumns,
    page,
    rowsPerPage,
    total,
    sortField,
    sortOrder,
    handlePageChange,
    handleRowsPerPageChange,
    handleSortChange,
    getActions,
    selectedLog,
    isViewLogOpen,
    handleCloseDialog,
    hasMore,
    serverSidePagination,
    handleFilterChange,
    filters,
  } = useLogsViewModel();

  if (error) {
    return <Typography color="error">Error: {error}</Typography>;
  }

  return (
    <div>
      <CustomTable
        columns={columns}
        data={logs || []}
        loading={loading}
        showActions={true}
        showAddButton={false}
        addButtonIcon={<HistoryIcon />}
        showSearch={true}
        showColumnVisibility={false}
        pageSize={rowsPerPage}
        page={page}
        totalCount={total}
        serverSidePagination={serverSidePagination}
        hasMore={hasMore}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handleRowsPerPageChange}
        onSortChange={handleSortChange}
        sortField={sortField}
        sortOrder={sortOrder}
        stickyHeader={true}
        fixedColumns={fixedColumns}
        actions={getActions}
        showFilters={true}
        staticFilters={true}
        staticColumnFilters={columnFilters}
        staticFilterValues={filters}
        onStaticFilterChange={handleFilterChange}
        title="System Logs"
        subtitle="View and monitor system activities"
        alignment="left"
        fontSize="12px"
      />
      {isViewLogOpen && (
        <ViewLog
          open={isViewLogOpen}
          onClose={handleCloseDialog}
          log={selectedLog}
        />
      )}
    </div>
  );
};

export default Logs;
